module.exports = __webpack_public_path__ + "static/media/HZN-BNB.17e559c9.svg";